import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/pantry_camera.png'
import _imports_1 from '@/assets/images/icon_checklist_line_plus.png'
import _imports_2 from '@/assets/images/icon_more_menu.png'


const _hoisted_1 = { class: "pantry-detail-page" }
const _hoisted_2 = { class: "pantry-detail-page-area" }
const _hoisted_3 = { class: "pantry-detail-page-header" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-detail-page-image-icon",
  src: _imports_0
}, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "pantry-detail-page-menu-camera-empty"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-detail-page-image-icon-shopping",
  src: _imports_1
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-detail-page-image-icon",
  src: _imports_2
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "pantry-detail-page-dummy-view" }, null, -1)
const _hoisted_9 = { class: "pantry-detail-page-bottom-view" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "pantry-detail-page-button-update" }, [
  /*#__PURE__*/_createVNode("div", { class: "pantry-detail-page-button-text" }, "変更を確定する")
], -1)
const _hoisted_11 = { class: "pantry-detail-page-date-value-dialog-area" }
const _hoisted_12 = { class: "pantry-detail-page-date-value-dialog-area" }
const _hoisted_13 = { class: "pantry-detail-page-date-value-dialog-area" }
const _hoisted_14 = { class: "pantry-detail-page-date-value-dialog-area" }
const _hoisted_15 = { class: "pantry-detail-page-date-value-dialog-area" }
const _hoisted_16 = { class: "pantry-detail-page-menu-area" }
const _hoisted_17 = { class: "pantry-detail-page-recommend-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryDetailView = _resolveComponent("PantryDetailView")
  const _component_PantryRecommendTitle = _resolveComponent("PantryRecommendTitle")
  const _component_PantryRecommendView = _resolveComponent("PantryRecommendView")
  const _component_PantryFoodInfoView = _resolveComponent("PantryFoodInfoView")
  const _component_PantryDateValueDialog = _resolveComponent("PantryDateValueDialog")
  const _component_PantryValueDialog = _resolveComponent("PantryValueDialog")
  const _component_PantryStroageValueDialog = _resolveComponent("PantryStroageValueDialog")
  const _component_PantryStockNotificationDialog = _resolveComponent("PantryStockNotificationDialog")
  const _component_PantryDetailGuideDialog = _resolveComponent("PantryDetailGuideDialog")
  const _component_PantryDetailMenuView = _resolveComponent("PantryDetailMenuView")
  const _component_PantryRecommendMainView = _resolveComponent("PantryRecommendMainView")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.isShowCamera)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "pantry-detail-page-menu-camera",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onShowCamera(...args)))
            }, [
              _hoisted_4
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_5)),
        (_ctx.isShowFavrite())
          ? (_openBlock(), _createBlock("div", {
              key: 2,
              class: "pantry-detail-page-menu-view",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickFavrite(...args)))
            }, [
              _createVNode("img", {
                class: "pantry-detail-page-image-icon-favorite",
                src: _ctx.favoriteImage
              }, null, 8, ["src"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: "pantry-detail-page-menu-view",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickShopList(...args)))
        }, [
          _hoisted_6
        ]),
        _createVNode("div", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickMenu(...args))),
          class: "pantry-detail-page-menu-view"
        }, [
          _hoisted_7
        ])
      ]),
      _createVNode(_component_PantryDetailView, _mergeProps(_ctx.detailInfo, {
        type: _ctx.type,
        info: _ctx.detailInfo,
        isShowData: _ctx.isShowData,
        onShowDataSetting: _ctx.onShowDataSetting,
        onChangeValue: _ctx.onChangeValue,
        onClickUpdatePlate: _ctx.onUpdatePlate,
        onShowGuide: _ctx.onShowGuide
      }), null, 16, ["type", "info", "isShowData", "onShowDataSetting", "onChangeValue", "onClickUpdatePlate", "onShowGuide"]),
      _withDirectives(_createVNode(_component_PantryRecommendTitle, {
        class: "pantry-detail-page-recommend-title",
        title: 'おすすめレシピ',
        type: _ctx.PANTRY_RECIPE_TYPE.RECOMMEND,
        onSelectSeeMore: _ctx.clickSeeMore
      }, null, 8, ["type", "onSelectSeeMore"]), [
        [_vShow, _ctx.isShowRecommendList()]
      ]),
      _withDirectives(_createVNode(_component_PantryRecommendView, {
        class: "pantry-detail-page-recommned-view",
        recipes: _ctx.recommendRecipes,
        onSelectRecipe: _ctx.onSelectRecipe
      }, null, 8, ["recipes", "onSelectRecipe"]), [
        [_vShow, _ctx.isShowRecommendList()]
      ]),
      _withDirectives(_createVNode(_component_PantryFoodInfoView, {
        info: _ctx.foodInfo,
        onShowGuide: _ctx.onShowGuide
      }, null, 8, ["info", "onShowGuide"]), [
        [_vShow, _ctx.isShowFoodInfo]
      ]),
      _hoisted_8
    ]),
    _withDirectives(_createVNode("div", _hoisted_9, [
      _createVNode("div", {
        class: "pantry-detail-page-button",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onUpdateValue(...args)))
      }, [
        _hoisted_10
      ])
    ], 512), [
      [_vShow, _ctx.isShowUpdateButton]
    ]),
    _withDirectives(_createVNode("div", _hoisted_11, [
      _createVNode(_component_PantryDateValueDialog, {
        key: _ctx.updateDateValueDialogKey,
        info: _ctx.dateValueInfo,
        onClickSetting: _ctx.onDateValueDialogSetting,
        onClickClose: _ctx.onDateValueDialogClose
      }, null, 8, ["info", "onClickSetting", "onClickClose"])
    ], 512), [
      [_vShow, _ctx.isShowDataValueDialog]
    ]),
    _withDirectives(_createVNode("div", _hoisted_12, [
      _createVNode(_component_PantryValueDialog, {
        value: _ctx.getStockValue(),
        onClickSetting: _ctx.onStockValueDialogSetting,
        onClickClose: _ctx.onStockValueDialogClose
      }, null, 8, ["value", "onClickSetting", "onClickClose"])
    ], 512), [
      [_vShow, _ctx.isShowStockValueDialog]
    ]),
    _withDirectives(_createVNode("div", _hoisted_13, [
      _createVNode(_component_PantryStroageValueDialog, {
        key: _ctx.updateStorageKey,
        value: _ctx.getStorageValue(),
        onClickSetting: _ctx.onStorageValueDialogSetting,
        onClickClose: _ctx.onStorageValueDialogClose
      }, null, 8, ["value", "onClickSetting", "onClickClose"])
    ], 512), [
      [_vShow, _ctx.isShowStorageValueDialog]
    ]),
    _withDirectives(_createVNode("div", _hoisted_14, [
      _createVNode(_component_PantryStockNotificationDialog, {
        data: _ctx.getUpdatePlateData(),
        maxStockValue: _ctx.getStockNotificationMaxStockValue(),
        displayFormat: _ctx.getDisplayFormat(),
        networkTiming: _ctx.getNetworkTiming(),
        time: _ctx.getStockNotificationTime(),
        stock: _ctx.getStockNotificationStock(),
        onClickSetting: _ctx.onStockNotificationDialogSetting,
        onClickClose: _ctx.onStockNotificationDialogClose
      }, null, 8, ["data", "maxStockValue", "displayFormat", "networkTiming", "time", "stock", "onClickSetting", "onClickClose"])
    ], 512), [
      [_vShow, _ctx.isShowStockNotificationDialog]
    ]),
    _withDirectives(_createVNode("div", _hoisted_15, [
      _withDirectives(_createVNode(_component_PantryDetailGuideDialog, { onClickClose: _ctx.onCloseGuideDialog }, null, 8, ["onClickClose"]), [
        [_vShow, _ctx.isShowGuideDialog]
      ])
    ], 512), [
      [_vShow, _ctx.isShowGuideDialog]
    ]),
    _withDirectives(_createVNode("div", _hoisted_16, [
      _createVNode(_component_PantryDetailMenuView, {
        type: _ctx.type,
        push: _ctx.push,
        onClickDelete: _ctx.onMenuDelete,
        onClickClose: _ctx.onMenuClose,
        onClickFoodChange: _ctx.onMenuFoodChange
      }, null, 8, ["type", "push", "onClickDelete", "onClickClose", "onClickFoodChange"])
    ], 512), [
      [_vShow, _ctx.isShowMenu]
    ]),
    _withDirectives(_createVNode("div", _hoisted_17, [
      _createVNode(_component_PantryRecommendMainView, {
        recipes: _ctx.recommendRecipes,
        onClickClose: _ctx.onCloseRecommend,
        onSelectRecipe: _ctx.onSelectRecipe
      }, null, 8, ["recipes", "onClickClose", "onSelectRecipe"])
    ], 512), [
      [_vShow, _ctx.isShowRecommend]
    ]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowSelectDialog,
      dialogType: 6,
      title: '',
      message: _ctx.selectMessage,
      messageAlign: 1,
      negativeLabel: '捨てちゃった',
      positiveLabel: '使い切った',
      onCloseClick: _ctx.onClickSelectClose,
      onNegativeClick: _ctx.onClickSelectNegative,
      onPositiveClick: _ctx.onClickSelectPositive
    }, null, 8, ["isShowDialog", "message", "onCloseClick", "onNegativeClick", "onPositiveClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowCompleteDialog,
      dialogType: 13,
      title: _ctx.completeMessage,
      negativeLabel: '閉じる',
      onNegativeClick: _ctx.onClickComplete
    }, null, 8, ["isShowDialog", "title", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowPlateFoodChange,
      dialogType: 18,
      title: '',
      message: '食材を変更します。\n重さリセットからやり直しますか？\n\n\n・使用するケースを変更する場合は必要です。\n・変更を中断した場合は食材が削除されますので、再度、食品登録をお願いします。',
      negativeLabel: 'キャンセル',
      positiveLabel: 'OK',
      onNegativeClick: _ctx.onClickPlateFoodChangeNegative,
      onPositiveClick: _ctx.onClickPlateFoodChangePositive
    }, null, 8, ["isShowDialog", "onNegativeClick", "onPositiveClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowErrorDialog,
      dialogType: 9,
      title: '入力内容に誤りがあります',
      message: _ctx.errorDialogMessage,
      negativeLabel: 'OK',
      onNegativeClick: _ctx.onClickError
    }, null, 8, ["isShowDialog", "message", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowErrorValueDialog,
      dialogType: 9,
      title: '入庫日の設定をお願いします',
      negativeLabel: 'OK',
      onNegativeClick: _ctx.onClickErrorValue
    }, null, 8, ["isShowDialog", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowPlateUpdateCheckDialog,
      dialogType: 8,
      title: 'このボタンはリアルタイム通信モード中のみご利用いただけます。\n\n（裏面の無線LANボタンを押すと10分間のみリアルタイム通信になります。普段は1時間or1日に１度の自動更新です。）',
      negativeLabel: 'OK',
      onNegativeClick: _ctx.onClickPlateUpdateCheckDialog
    }, null, 8, ["isShowDialog", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: 9,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      negativeLabel: _ctx.ERROR_BUTTON_LABEL,
      onNegativeClick: _ctx.closeError
    }, null, 8, ["isShowDialog", "title", "message", "negativeLabel", "onNegativeClick"])
  ]))
}